export default __webpack_public_path__ + "static/media/upool_splash_screen.db04b9a2.svg";